export default {
  en: {
    titleLineOne: 'Thanks for',
    titleLineTwo: 'signing up!',
    subtitle: 'We have received your request. Our team will be in touch once your '
      + 'account has been approved.',
  },
};
